import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { type MaxReferralBonusConfig } from "@src/appV2/FeatureFlags/types";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

import { DEFAULT_MAX_REFERRAL_BONUS_AMOUNT_IN_DOLLARS } from "./constants";

export function useMaxReferralBonusAmount(type: keyof MaxReferralBonusConfig): number {
  const config = useCbhFlag(CbhFeatureFlag.MAX_REFERRAL_BONUS_CONFIG, {
    defaultValue: {
      onboardingBonusInDollars: DEFAULT_MAX_REFERRAL_BONUS_AMOUNT_IN_DOLLARS,
      postOnboardingBonusInDollars: DEFAULT_MAX_REFERRAL_BONUS_AMOUNT_IN_DOLLARS,
    },
  });

  return config[type];
}
